import type { ReactNode } from "react";

interface Props {
  // Title can contain inline <em> for typography emphasis. Pass as JSX.
  title: ReactNode;
  subtitle?: ReactNode;
  children?: ReactNode;
  // When children are present, layout side-by-side.
  layout?: "stacked" | "split";
}

export function PageHeader({ title, subtitle, children, layout = "stacked" }: Props) {
  const splitStyle: React.CSSProperties =
    layout === "split"
      ? {
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 16,
          flexWrap: "wrap",
        }
      : {};
  return (
    <div className="page-header" style={splitStyle}>
      <div>
        <div className="page-title">{title}</div>
        {subtitle && <div className="page-subtitle">{subtitle}</div>}
      </div>
      {children}
    </div>
  );
}
